import { render, staticRenderFns } from "./NotebookEdit.vue?vue&type=template&id=60408c64&"
import script from "./NotebookEdit.vue?vue&type=script&lang=js&"
export * from "./NotebookEdit.vue?vue&type=script&lang=js&"
import style0 from "./NotebookEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports